<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Sleepy Sheep</h1>
<p class="BOD2">This smiley sheep is perfect as a mobile or dream catcher to help you on your way to the land of nod and sweet dreams.</p>
<p class="IMAGE"><img alt="" src="images/C1-25.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-26.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-13.vue?4c5b8fb8